import { Grid, styled } from '../../../../base';
import { StyledBody as StyledBodyBase } from '../EmailTab.styles';

export const StyledContainer = styled(Grid)(({ theme }) => ({
    paddingBottom: theme.spacing(3),
    width: '100%',
    alignItems: 'flex-start',
    '&:not(:last-child)': {
        marginBottom: theme.spacing(2),
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
}));

export const StyledBody = styled(StyledBodyBase)(() => ({
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
}));
